import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import {
  Pane,
  TextInputField,
  Button,
  Heading,
  toaster
} from 'evergreen-ui';
import { useAuth } from '../context/AuthContext';
import api from '../services/api';

function Signup() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { setIsAuthenticated } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Basic validation
    if (password !== confirmPassword) {
      toaster.danger('Passwords do not match');
      return;
    }

    setIsLoading(true);
    try {
      const response = await api.post('/signup', {
        email,
        password,
      });

      const data = response.data;

      // Token is automatically stored in cookies by the backend
      setIsAuthenticated(true);
      
      toaster.success('Signup successful!');
      navigate('/dashboard');
    } catch (error) {
      toaster.danger(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Pane
      display="flex"
      alignItems="center"
      justifyContent="center"
      height="100vh"
      background="tint2"
    >
      <Pane
        elevation={1}
        background="white"
        padding={40}
        width={400}
        borderRadius={8}
      >
        <Heading size={700} marginBottom={20} textAlign="center">
          Create Account
        </Heading>
        
        <form onSubmit={handleSubmit}>
          <TextInputField
            label="Email"
            type="email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            placeholder="Enter your email"
            required
          />
          
          <TextInputField
            label="Password"
            type="password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            placeholder="Enter your password"
            required
          />

          <TextInputField
            label="Confirm Password"
            type="password"
            value={confirmPassword}
            onChange={e => setConfirmPassword(e.target.value)}
            placeholder="Confirm your password"
            required
          />

          <Button
            appearance="primary"
            isLoading={isLoading}
            type="submit"
            width="100%"
            height={40}
            marginBottom={16}
          >
            Sign Up
          </Button>

          <Pane textAlign="center">
            <Link to="/login" style={{ textDecoration: 'none' }}>
              Log in
            </Link>
          </Pane>
        </form>
      </Pane>
    </Pane>
  );
}

export default Signup; 